import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User added a field to collection form',
  name: 'Added a field to collection form',
  params: [
    {
      description: 'The ID of the field that was added',
      name: 'fieldId',
      required: false,
      type: 'string',
    },
    {
      description: 'The name of the field that was added',
      name: 'fieldName',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
